<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <div v-if="!loading">
            <component-header
                title="Commission Rule"
                :isLoading="isloading"
                @reload-data="reloadData"
                @create-press="$router.push({ path: 'commission/create' })"
                createButtonText="Create Commission Rule"
                :hasback="false"
                @search-query="(val) => (filter = val)"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        class="table-radius professional-stacked-table"
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive
                        :items="commissionRuleList"
                        :fields="commissionRuleColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        show-empty
                    >
                        <template slot-scope="data" slot="commission.rate">
                            {{ (data.item.commission.rate * 100).toFixed(2) }}%
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <div class="inline_btnTable">
                                <ActionButtonGroup
                                    showView
                                    :showEdit="data.item.active"
                                    :showDelete="data.item.active"
                                    @view="viewRule(data.item)"
                                    @edit="editRule(data.item)"
                                    @delete="deleteRule(data.item)"
                                />
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="commissionRuleList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "CommissionRuleList",
    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            currentPage: 1,
            perPage: 8,
            sortBy: "createdAt",
            sortDesc: true,
            commissionRuleColumns: [
                {
                    key: "ruleName",
                    label: "Rule Name",
                    thStyle: { width: "18%" },
                },
                {
                    key: "ruleType",
                    label: "Rule Type",
                    thStyle: { width: "15%" },
                },
                {
                    key: "commission.applicableTo",
                    label: "Applicable To",
                    thStyle: { width: "18%" },
                },
                {
                    key: "commission.appliedOn",
                    label: "Applied On",
                    thStyle: { width: "18%" },
                },
                {
                    key: "commission.rate",
                    label: "Rate",
                    thStyle: { width: "12%" },
                },
                {
                    key: "action",
                    label: "Action",
                    thClass: "customer-col-action",
                    tdClass: "customer-col-action",
                    thStyle: { width: "19%" },
                },
            ],
        };
    },
    components: {
        ComponentHeader,
        AtomSpinner,
        ActionButtonGroup,
    },
    computed: {
        ...mapGetters({
            getFetchCommissionRule: "commission/GetFetchCommissionRule",
        }),
        commissionRuleList() {
            return this.getFetchCommissionRule.filter((x) => x.active);
        },
    },
    methods: {
        navigateToRule(data, routeName) {
            this.$router.push({
                name: routeName,
                params: { id: data._id },
            });
        },
        viewRule(data) {
            this.navigateToRule(data, "CommissionSetupView");
        },
        editRule(data) {
            this.navigateToRule(data, "CommissionSetupEdit");
        },
        async reloadData() {
            this.isloading = true;
            await this.$store.dispatch("commission/fetchCommissionRuleAction");
            this.isloading = false;
        },
        async deleteRule(data) {
            this.$swal({
                title: "Delete this Commission Rule?",
                text: "Are you sure?This will be Remove?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.isloading = true;
                    this.$store
                        .dispatch(
                            "commission/deleteCommissionRuleAction",
                            data._id,
                        )
                        .then((result) => {
                            this.$swal({
                                title: "Success",
                                text: "Commission Rule Deleted Successfully!",
                                type: "success",
                            });
                        })
                        .finally(() => {
                            this.isloading = false;
                        });
                }
            });
        },
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch("commission/fetchCommissionRuleAction");
        this.loading = false;
    },
};
</script>
<style scoped>
.btn-edit-commission {
    background: #fe7b08;
    border-color: #fe7b08;
}

.table-radius {
    border-radius: 12px;
}

.inline_btnTable {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
}

.inline_btnTable .button-circle {
    flex-shrink: 0;
    margin-right: 0 !important;
    margin-left: 0 !important;
}

@media (max-width: 575.98px) {
    .inline_btnTable {
        gap: 4px;
    }
}
</style>
